import storage from 'didi-store'
import { VueJed, sprintf } from '@didi/gettext'
// import { isObject } from 'lodash-es'
// import enUS from '../../locale/en-US/soda-bd.po'
// import zhCN from '../../locale/zh-CN/soda-bd.po'
// import esMX from '../../locale/es-MX/soda-bd.po'
// import ptBR from '../../locale/pt-BR/soda-bd.po'
// import jaJP from '../../locale/ja-JP/soda-bd.po'

import enUS from '../../i18n/en-US'
import zhCN from '../../i18n/zh-CN'
import esMX from '../../i18n/es-MX'
import ptBR from '../../i18n/pt-BR'
import jaJP from '../../i18n/ja-JP'
import esCR from '../../i18n/es-CR'

let map = {
  'zh-CN': zhCN,
  'en-US': enUS,
  'es-MX': esMX,
  'pt-BR': ptBR,
  'ja-JP': jaJP,
  'es-CR': esCR
}
const LOCALE_KEY = 'BD_LOCALE'
const COUNTRY_KEY = 'BD_COUNTRY'
const TIME_ZONE_KEY = 'BD_TIME_ZONE'

// 获取当前语言环境
export function getBDLocale () {
  storage.get(LOCALE_KEY)
  let locale = storage.get(LOCALE_KEY) || 'en-US'
  return locale
}

// 获取当前地区
export function getBDCountry () {
  let country = storage.get(COUNTRY_KEY)
  return country
}

// 获取当前地区时区
export function getBDTimezone () {
  let country = storage.get(TIME_ZONE_KEY)
  return country
}

// 设置当前语言环境
export function setBDLocale (locale) {
  storage.set(LOCALE_KEY, locale)
}

// 设置当前地区
export function setBDCountry (country) {
  storage.set(COUNTRY_KEY, country)
}

// 设置当前地区时区
export function setBDTimezone (timezone) {
  storage.set(TIME_ZONE_KEY, timezone)
}

export let i18n = new VueJed(map[getBDLocale()] || enUS)
export { sprintf }

export const COUNTRY_OPTIONS = [
  {
    value: 'MX',
    text: i18n.gettext('墨西哥'),
    index: 0,
    children: [{
      value: 'America/Mexico_City',
      text: 'America/Mexico_City'
    }]
  },
  {
    value: 'BR',
    text: i18n.gettext('巴西'),
    index: 1,
    children: [{
      value: 'America/Sao_Paulo',
      text: 'America/Sao_Paulo'
    }]
  },
  {
    value: 'JP',
    text: i18n.gettext('日本'),
    index: 2,
    children: [{
      value: 'Asia/Tokyo',
      text: 'Asia/Tokyo'
    }]
  }
]

export const LOCALE_OPTIONS_MX = [
  {
    value: 'es-MX',
    text: 'Español'
  },
  {
    value: 'en-US',
    text: 'English'
  },
  {
    value: 'zh-CN',
    text: '中文'
  }
]

export const LOCALE_OPTIONS_BR = [
  {
    value: 'pt-BR',
    text: 'Português'
  },
  {
    value: 'en-US',
    text: 'English'
  },
  {
    value: 'zh-CN',
    text: '中文'
  }
]

export const LOCALE_OPTIONS_JP = [
  {
    value: 'ja-JP',
    text: '日本語'
  },
  {
    value: 'en-US',
    text: 'English'
  },
  {
    value: 'zh-CN',
    text: '中文'
  }
]

export const CONTRIES_MAP = {
  CHILE: {
    alpha: 'CL',
    name: 'Chile',
    label: i18n.gettext('智利')
  },
  MEXICO: {
    alpha: 'MX',
    name: 'Mexico',
    label: i18n.gettext('墨西哥')
  },
  COLOMBIA: {
    alpha: 'CO',
    name: 'Colombia',
    label: i18n.gettext('哥伦比亚')
  },
  JAPAN: {
    alpha: 'JP',
    name: 'Japan',
    label: i18n.gettext('日本')
  },
  BRAZIL: {
    alpha: 'BR',
    name: 'Brazil',
    label: i18n.gettext('巴西')
  },
  COSTA_RICA: {
    alpha: 'CR',
    name: 'Costa Rica',
    label: i18n.gettext('哥斯达黎加')
  },
  DOMINICANA: {
    alpha: 'DO',
    name: 'Dominicana',
    label: i18n.gettext('多明尼加')
  }
}

export function isCountryChile () {
  return getBDCountry() === CONTRIES_MAP.CHILE.alpha
}
